import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import React from 'react';

import { ownerService } from 'app/Domain/Owners/Services/OwnerService';
import { useSnakeBar } from 'app/hooks/useSnakeBar';
import type { UseQueryWrapper, UserOwner } from 'app/types';

type GetUserEnvironmentsQueryVariables = { userId: string };
type UserEnvironmentsResponse = { 'hydra:member': Array<UserOwner> };
const QUERY_KEY = 'getUserEnvironments';

export const useUserGetEnvironmentsQuery: UseQueryWrapper<Array<UserOwner>, GetUserEnvironmentsQueryVariables> = ({
  variables,
  options,
}) => {
  const { showErrorSnakeBar } = useSnakeBar();
  const onError = React.useCallback(() => showErrorSnakeBar({ method: QUERY_KEY }), [showErrorSnakeBar]);

  return useQuery<Array<UserOwner>>(
    [QUERY_KEY, variables.userId],
    async () => {
      const response = (await ownerService.getUserEnvironment(
        variables.userId,
      )) as AxiosResponse<UserEnvironmentsResponse>;
      return response.data['hydra:member'];
    },
    {
      onError,
      ...(options || {}),
    },
  );
};
